// components/shared/SearchInput/SearchInput.tsx
import React, { useState } from "react";
import { FiSearch, FiX } from "react-icons/fi";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  width?: string | number;
  autoFocus?: boolean;
  onClear?: () => void;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className = "",
  width = "300px",
  autoFocus = false,
  onClear,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleClear = () => {
    onChange("");
    if (onClear) onClear();
  };

  return (
    <div
      className={`position-relative ${className}`}
      style={{
        width,
        transition: "all 0.3s ease",
      }}
    >
      <div
        className="d-flex align-items-center px-3"
        style={{
          height: "44px",
          borderRadius: "50px",
          border: isFocused ? "1.5px solid #4e73df" : "1px solid #e0e0e0",
          backgroundColor: "#ffffff",
          boxShadow: isFocused
            ? "0 2px 8px rgba(78, 115, 223, 0.08), 0 0 0 1px rgba(78, 115, 223, 0.02)"
            : "0 1px 3px rgba(0,0,0,0.04)",
          transition: "all 0.2s ease",
        }}
      >
        <FiSearch
          size={20}
          className="flex-shrink-0"
          style={{
            color: isFocused ? "#4e73df" : "#adb5bd",
            transition: "color 0.2s ease",
          }}
        />

        <input
          type="text"
          className="flex-grow-1 border-0 bg-transparent px-2 py-2"
          style={{
            outline: "none",
            fontSize: "14px",
            color: "#333",
            minWidth: 0,
          }}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          autoFocus={autoFocus}
        />

        {value && (
          <button
            type="button"
            className="btn btn-link p-0 text-muted flex-shrink-0"
            onClick={handleClear}
            style={{
              fontSize: "18px",
              lineHeight: 1,
              textDecoration: "none",
            }}
          >
            <FiX size={18} />
          </button>
        )}
      </div>
    </div>
  );
};
